import { ComboboxPlacements, ListboxOption, StandardCombobox } from '@brandfolder/react';
import React, { ReactElement } from 'react';

interface ShareLinksSortComboboxProps {
  selectSort: (sortBy: string) => void;
}

export const ShareLinksSortCombobox = ({ selectSort }: ShareLinksSortComboboxProps):ReactElement => {

  return (
    <StandardCombobox
      className='sort-by-combobox'
      id='sort-share-links'
      initialSelectedIndex={4}
      labels={{
        emptyLabel: bfTranslate('No sorting options available'),
        iconButtonLabel: bfTranslate('Select share links sort'),
        label: bfTranslate('Sort by'),
        listboxLabel: bfTranslate('List of states and territories'),
        loaderLabel: bfTranslate('Loading'),
        requiredLabel: bfTranslate('Required')
      }}
      onSelection={(option: ListboxOption): void => selectSort(option.value as string)}
      options={[
        {
          children: <>{bfTranslate('Name (A-Z)')}</>,
          key: 0,
          value: 'name asc'
        },
        {
          children: <>{bfTranslate('Name (Z-A)')}</>,
          key: 1,
          value: 'name desc'
        },
        {
          children: <>{bfTranslate('Created by (A-Z)')}</>,
          key: 2,
          value: 'created_by asc'
        },
        {
          children: <>{bfTranslate('Created by (Z-A)')}</>,
          key: 3,
          value: 'created_by desc'
        },
        {
          children: <>{bfTranslate('Creation Date (Newest)')}</>,
          key: 4,
          value: 'created_at desc'
        },
        {
          children: <>{bfTranslate('Creation Date (Oldest)')}</>,
          key: 5,
          value: 'created_at asc'
        },
      ]}
      placement={ComboboxPlacements.BottomStart}
      showPlaceholderOption={false}
    />
  );
};
